import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { InsuranceOwnerFormValues } from "Components/Form/CommonFormElements/InsuranceOwnerFormElement/interfaces";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";
import { UsabilityCode } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Motorcycle";
import { MotorcycleCoverage } from "Store/interfaces/products/coverage";
import { TfaAmount } from "../vehicleInterfaces";

export interface MotorcycleProductIntroFormValues {
  year: string;
  brand: string;
  model: string;
  bonus: string;
}

export interface MotorcycleProductDetailsFormValues
  extends InsuranceOwnerFormValues,
    InjuriesFormValues {
  usabilityCode: UsabilityCode;
  mortgagee: BooleanFormType;
  mcLocker: BooleanFormType;
  garage: BooleanFormType;
}

export interface MotorcycleProductPriceFormValues extends TfaAmount {
  deductible: string;
  coverage: MotorcycleCoverage;
}

export interface MotorcyclePriceRequestInfo extends BaseProduct {
  year: number;
  brand: string;
  model: string;
  bonusLevelCode: string;

  insuranceHolderIsMCOwner: boolean;
  mcOwnerAge: string | null;

  injuries: number;
  injuryYear?: number;

  usabilityCode: UsabilityCode;
  mortgagee: boolean;
  mcLocker: boolean;
  garage: boolean;

  dateOfBirth?: string;
}

export enum MotorcycleInsuranceType {
  MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT = "motorcycleAnsvar",
  MOTORCYCLE_REDUCED_OWN_DAMAGE = "motorcycleDelkasko",
  MOTORCYCLE_FULL_OWN_DAMAGE = "motorcycleKasko",
}

type MotorcycleTile = {
  productIntro: {
    ingress: TranslatedText;
  };
  productDetails: {
    heading: TranslatedText;
    ingress: TranslatedText;
  };
  productPrice: {
    heading: TranslatedText;
    ingress: TranslatedText;
    deductibleInfo: {
      title: TranslatedText;
      description: TranslatedText;
    };
  };
};

type MotorcycleFormTexts = {
  [key: string]: {
    label: TranslatedText;
    hint: TranslatedText;
    options: Record<string, TranslatedText>;
    error: Record<string, TranslatedText>;
    [key: string]: any;
  };
};
export interface MotorcycleTexts {
  details: {
    [key: string]: Record<TextLanguage, string>;
  };
  formText: { checkPrice: MotorcycleFormTexts };
  tile: MotorcycleTile;
  title: TranslatedText;
  name: TranslatedText;
  types: {
    coverageGroup: Record<MotorcycleCoverage, TranslatedText>;
  };
}
